import React, { useEffect, useState } from 'react';
import { Row, Tabs, theme, message, Col } from 'antd';
import './PaymentTabs.css';
import CardIcon from "../../../Assets/paymentIcon/credit_card.png";
import UpiIcon from "../../../Assets/paymentIcon/upi_bank.png";
import NetBankingIcon from "../../../Assets/paymentIcon/net_banking.png";
import CardlessEMI from "../../../Assets/paymentIcon/EMi.png";
import Wallet from "../../../Assets/paymentIcon/wallet.png";
import FooterButton from '../../Footer';
import { useDispatch, useSelector } from 'react-redux';
import { payment_option } from '../../../Constant';
import { makePayment } from '../../../Services/payment';
import { useNavigate } from 'react-router-dom';
import { Payload_entry, SAVE_PAYMENT, SET_PAYMENT_MODE, SET_SUCCESSFULL_PAYMENT } from '../../../Redux/PolicyNumber/types';
import moment from 'moment';
import { postApi } from '../../../Services/apiService';
import { generate_orderID, REVERSE_FEED } from '../../../Services/endpoints';
import { decrypt, encrypt } from '../../../Services/AESEncryptionDecryption';
import { InfoCircleOutlined } from '@ant-design/icons';
//import '../../../Components/Card/card.css';
import { enabledRazorPay } from '../../../Utils/constant';
import { createPayUOrder, getHashData, getPaymentGateway, loadScript } from '../../../Utils';
import { v4 as uuidv4 } from 'uuid';


const methodList = [
    {
        method: "card",
    },
    {
        method: "paylater",
    },
    {
        method: "emi",
    },
    {
        method: "wallet",
    },
    {
        method: "netbanking",
    },
    {
        method: "upi",
    },
]

const paymentTabs = [
    { key: 'creditcard', name: 'Credit Card', icon: CardIcon, alt: 'card' },
    { key: 'debitcard', name: 'Debit Card', icon: CardIcon, alt: 'card' },
    { key: 'netbanking', name: 'Net Banking', icon: NetBankingIcon, alt: 'NetBanking' },
    { key: 'emi', name: 'Cardless EMI', icon: CardlessEMI, alt: 'CardlessEMI' },
    { key: 'wallet', name: 'Wallet', icon: Wallet, alt: 'Wallet' },
    { key: 'upi', name: 'UPI', icon: UpiIcon, alt: 'Upi' }
]

const tabItems = paymentTabs.map((item) => {
    return (
        {
            key: item.key,
            label: (
                <div className="tab-label">
                    <span className="pc_img">
                        <img src={item.icon} alt={item.alt} />
                    </span>
                    <span>{item.name}</span>
                </div>
            ),
        }
    )
})

const PaymentTabs = () => {
    const { token } = theme.useToken();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const userDBData = useSelector(
        (state) => state.policyDetails.savePaymentDetails
    );
    const userData = useSelector(
        (state) => state.policyDetails.userData
    );
     const activatePaymentModeType = useSelector(
        (state) => state.policyDetails.activatePaymentModeType
    );
    const triggerPaymentMode = activatePaymentModeType?.nextPaymentGateway

    let { tncCheck, pancard, email, mobile, inputAmount } = userData;
    const userDBDataExtraInfo = useSelector((state) => state.policyDetails);
    // Added for Belstar
    const belstarAvailable = useSelector((state) => state.belstarAvailable);
    const { isVendorBelstar, uniqueIdentifier } = belstarAvailable;

    const [paymentMethod, setPaymentMethod] = useState(isVendorBelstar ? 'upi' : 'creditcard')

    const belstarDetails = useSelector((state) => state.belstarDetails);
    const { memberName: belstarMemberName, memberLastName: belstarMemberLastName } = belstarDetails;

    let {
        proposalType,
        paymentFor,
        policyNumber,
        proposalNumber,
        amount: userDBAmount,
        contactNum,
        emailAddress,
    } = userDBData;

    const amount = !!parseInt(userDBAmount) ? userDBAmount : inputAmount;
    let { name, firstName, lastName, isUpiAsba } = userDBDataExtraInfo;
    name = name.trim()

    const paymentMethodMApping = {
        'debitcard': 'card',
        'creditcard': 'card',
        'netbanking': 'netbanking',
        'upi': 'upi',
        'emi': 'emi',
        'upi_asba': 'upi',
        'wallet': 'wallet'
    }


    useEffect(() => {

        async function getPaymentModel() {
            const response = await getPaymentGateway(policyNumber !== "" ? policyNumber : proposalNumber)
            const decryptResp = JSON.parse(
                decrypt(response)
            );
            dispatch({ type: SET_PAYMENT_MODE, payload: decryptResp });
        }
        if (!triggerPaymentMode) {
            getPaymentModel()
        }
        loadScript()
    }, [])

    const paymentVerify = async (orderId, razorpay_key, customerId = "", selectedPaymentMethod) => {
        let userLastname = name.split(" ")[name.split(" ").length - 1]
        if (name.split(" ").length === 1) {
            userLastname = "NA"
        }
        const filteredHideOptions = methodList?.filter((item) => item?.method !== paymentMethodMApping[selectedPaymentMethod])

        let res;
        try {
            res = await makePayment({
                quoteId: "",
                isUpiAsba,
                customerId,
                totalAmount: `${parseFloat(amount) * 100}`,
                orderId,
                currency: "INR",
                name: name,
                description: `payment for policy number  ${policyNumber !== "" ? policyNumber : proposalNumber
                    }`,
                policyNum: `${policyNumber !== "" ? policyNumber : proposalNumber}`,
                mobileNumber: mobile,
                emailId: email,
                razorpay_key,
                pancard,
                firstName: `${paymentFor === payment_option[0].value &&
                    proposalType === "New Business"
                    ? name.split(" ")[0]
                    : firstName
                    }`,
                lastName: `${paymentFor === payment_option[0].value &&
                    proposalType === "New Business"
                    ? userLastname
                    : lastName
                    }`,
                filteredHideOptions,
            });
            dispatch({
                type: Payload_entry,
                payload: { transactionId: res.transactionId },
            });
        } catch (err) {
            console.error(err);
            return message.error(err.successMessage);
        }

        const sellBaseUrl = process.env.REACT_APP_SELL_URL;

        const payload = {
            applicationNumber: policyNumber !== "" ? policyNumber : proposalNumber,
            premiumAmount: amount,
            paymentDate: moment().format("DD/MM/YYYY"),
            proposerFirstName: res?.firstName,
            proposerLastName: res?.lastName,
            proposerMobileNumber: contactNum,
            proposerEmailId: emailAddress,
            paymentType: "DIRECTDEBIT",
            paymentStatus: res?.paymentStatus === "Success" ? 1 : 0,
            orderId: res?.orderId,
            transactionId: res?.transactionId
        };
        if (res?.paymentStatus === "Success") {
            try {
                // setTimeout(() => {
                //   document.body.classList.remove("loading-indicator-api");
                //   navigate("/thankyou", { replace: true });
                // }, 3000);
                // const apiRes = await postApi(PAYMENT_VERIFY, {
                //   ...res,
                // });
                dispatch({ type: SET_SUCCESSFULL_PAYMENT, payload: "RAZORPAY" });
                const reverseFeedRes = await postApi(REVERSE_FEED, payload,
                    { baseURL: sellBaseUrl }
                );
                navigate("/thankyou", { replace: true });
            } catch (err) {
                console.error(err);
                navigate("/thankyou", { replace: true });
            }
        }
        else {
            try {
                const reverseFeedRes = await postApi(REVERSE_FEED, payload, {
                    baseURL: sellBaseUrl,
                });
            } catch (err) {
                console.error(err);
            }
        }
    };

    const getOrderId = async () => {
        let userLastname = name.split(" ")[name.split(" ").length - 1]
        if (name.split(" ").length === 1) {
            userLastname = "NA"
        }
        const belstarReqObject = {
            uniqueIdentifier: uniqueIdentifier,
            totalAmount: "613.60",
            panNumber: "",
            ...(paymentMethod === 'emi'
                ? {}
                : { method: paymentMethod }),
            firstName: belstarMemberName,
            lastName: belstarMemberLastName,
            isBelStar: isVendorBelstar,
        };

        const reqObject = {
            uniqueIdentifier: `${policyNumber !== "" ? policyNumber : proposalNumber
                }`,
            totalAmount: amount,
            panNumber: pancard,
            ...(paymentMethod === 'emi'
                ? {}
                : { method: paymentMethod }),
            firstName: `${paymentFor === payment_option[0].value &&
                proposalType === "New Business"
                ? name.split(" ")[0]
                : firstName
                }`,
            lastName: `${paymentFor === payment_option[0].value &&
                proposalType === "New Business"
                ? userLastname
                : lastName
                }`,
        };
        const encryptedPayload = encrypt(JSON?.stringify(isVendorBelstar ? belstarReqObject : reqObject));
        try {
            const res = await postApi(generate_orderID, {
                encodedString: encryptedPayload
            });
            const decryptedRes = JSON?.parse(decrypt(res?.data?.response));
            if (decryptedRes?.orderId) {
                paymentVerify(decryptedRes?.orderId, decryptedRes?.apiKey, decryptedRes?.customerId, paymentMethod);
            }
        }
        catch (err) {
            console?.error(err)
            /** payu will trigger if razorpay fails*/
            if (paymentMethod !== "emi") {
                initiatePayUPayment()
            }
        }
    };
    const initiatePayUPayment = async () => {
         var txnId = uuidv4();
         let userLastname = name.split(" ")[name.split(" ").length - 1]
        if (name.split(" ").length === 1) {
            userLastname = "NA"
        }
        let payuCreateOrderReqobj = {
             uniqueIdentifier: `${policyNumber !== "" ? policyNumber : proposalNumber
                }`,
            totalAmount: amount,
            panNumber: pancard,
            firstName: `${paymentFor === payment_option[0].value &&
                proposalType === "New Business"
                ? name.split(" ")[0]
                : firstName
                }`,
            lastName: `${paymentFor === payment_option[0].value &&
                proposalType === "New Business"
                ? userLastname
                : lastName
                }`,
            email:  email,
            txnid:txnId
        };
        try {
            const orderRes = await createPayUOrder(payuCreateOrderReqobj)
            const decryptedOrderRes = JSON.parse(decrypt(orderRes.response));
            const data = {
                amount: amount,
                productinfo: 'BOLT',
                firstname: `${paymentFor === payment_option[0].value &&
                    proposalType === "New Business"
                    ? name.split(" ")[0]
                    : firstName
                    }`,
                email: email,
                udf1: `${policyNumber !== "" ? policyNumber : proposalNumber}`,
                udf2: decryptedOrderRes
            };
            const response = await getHashData(data)
            const res = JSON.parse(decrypt(response.response));
            const payUDATA = {
                ...data,
                txnid: res.transactionId,
                key: res.key, // merchant key
                phone: mobile,
                surl: `${process.env.REACT_APP_BASE_URL}/thankyou`, 
                furl:`${process.env.REACT_APP_BASE_URL}/payment`,
                hash: res.hash
            }
            window.bolt.launch(payUDATA, {
                responseHandler: function (BOLT) {
                    if (BOLT.response.txnStatus == "SUCCESS") {
                        dispatch({
                            type: Payload_entry,
                            payload: { transactionId: BOLT.response.mihpayid },
                        });
                        dispatch({ type: SET_SUCCESSFULL_PAYMENT, payload: "PAYU" });

                        navigate("/thankyou", { replace: true });
                    }
                    if (BOLT.response.txnStatus == "FAILED") {
                        console.log('Payment failed. Please try again.');
                    }
                    if (BOLT.response.txnStatus == "CANCEL") {
                        console.log('Payment failed. Please try again.');
                    }
                },
                catchException: function (error) {
                    console.error('error', error);
                }
            })

        } catch (error) {
            console.log('error initiating payment', error)
            /** razorpay will trigger if payU fails */
            getOrderId();

        }

    }

   
  function handlePayment() {
    if(enabledRazorPay.includes(paymentMethod)){
      getOrderId()
      return
    }
    if (triggerPaymentMode === "PAYU") {
      initiatePayUPayment()
    } else if (triggerPaymentMode === "RAZORPAY") {
      getOrderId()
    } else {
      getOrderId()
    }
  }


    const convenienceFeeMessage = 'Non-Refundable convenience fees will be applicable. Please use UPI to avoid charges.'

    const MessageComponent = () => (
       
        <div className=' cg-card cg-card--white'>
                <InfoCircleOutlined  style={ {color:'blue',}} />
            <div className='cg-card__label cg-card__label--margin'>{convenienceFeeMessage}</div>
        </div>
    )

const messageEnableArr = ['creditcard','wallet']

    return (
        <div style={{ backgroundColor: token.colorBgContainer, padding: token.padding, borderRadius: token.borderRadius }}>
            <Tabs
                defaultActiveKey={isVendorBelstar ? "upi" : "creditcard"}
                items={tabItems}
                className="payment-tabs-navigation"
                centered
                onChange={(e) => setPaymentMethod(e)}
            />
            {/* {messageEnableArr.includes(paymentMethod) && (
                <MessageComponent />
            )} */}
            <FooterButton
                hideBack={true}
                nextLabel="Pay"
                onNext={handlePayment}
            />
        </div>

    );
};

export default PaymentTabs;
